import { MultiSelect, type MultiSelectProps } from '@mantine/core';

export interface MultiSelectInputProps extends Omit<MultiSelectProps, 'size'> {
  size?: MultiSelectProps['size'];
}

/** MultiSelect preconfigured with Optiro defaults (clearable, searchable, hides picked options, Danish empty state). */
export function MultiSelectInputView({ size = 'sm', ...props }: MultiSelectInputProps) {
  return (
    <MultiSelect
      size={size}
      clearable
      searchable
      hidePickedOptions
      maxDropdownHeight={220}
      nothingFoundMessage="Ingen resultater"
      {...props}
    />
  );
}
